import React from 'react';
import SectionClosingStockReport from '../SectionClosingStockReport';
import * as greigeSectionApi from '@/services/greigeSectionApi';

const GreigeSectionClosingStock = () => {
  return (
    <SectionClosingStockReport
      sectionName="Greige Section"
      backRoute="/sections/greige"
      fetchClosingStock={greigeSectionApi.getGreigeClosingStock}
      fetchOperations={greigeSectionApi.getGreigeOperations}
      exportPrefix="greige"
      summaryGroupBy="operation"
      showBundleCount={true}
    />
  );
};

export default GreigeSectionClosingStock;
